var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"lions-club-imprint",attrs:{"href":"https://magglingen.lionsclub.ch/","rel":"noopener","target":"_blank"}},[_c('figure',{staticClass:"lions-club-logo"},[_c('img',{staticClass:"lions-club-logo-img",attrs:{"src":require("../../../assets/logo-lions-club.svg"),"alt":"Lions Club Logo"}})])])
}]

export { render, staticRenderFns }